import {
  LanguageType,
  SettingWhtItem40XShowingType,
  WithholdingTaxPageSizeType,
  WitholdingTaxDocumentDisplayType,
} from "@/enums/enums";
import { GetCredential } from "@/helper/documentFacadeHelper";
import { GetWitholdingTaxDocumentData } from "@/helper/witholdingTaxDocumentHelper";
import { SettingWitholdingTaxDocumentTemplateModel } from "@/model/document/settingDocumentTemplate";
import {
  WitholdingTaxDocumentDetailModel,
  WitholdingTaxOnlineViewModel,
} from "@/model/document/witholdingTaxDocumentModal";

export function ConvertToWitholdingTaxOnlineView(detail: any): WitholdingTaxOnlineViewModel {
  const onlineViewModel: WitholdingTaxOnlineViewModel = new WitholdingTaxOnlineViewModel();
  if (detail) {
    const documentDetailModel: WitholdingTaxDocumentDetailModel = new WitholdingTaxDocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetWitholdingTaxDocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = detail.financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.template = detail.template ? detail.template.data : GetWitholdingTaxSettingDocument();
    onlineViewModel.credential = GetCredential(detail.credential);
    onlineViewModel.headerOptionType = detail.headerOptionType;
  }

  return onlineViewModel;
}

export function PrepareUpdateDetailWithHoldingTaxDocumentInputData(input: any){
  const data = {
    sourceType: input.sourceType,
    transactionId: input.transactionId,
    updateVersion: input.updateVersion,
    language: LanguageType.Th,
  };
  return data;
}

export function PrepareWithHoldingTaxDocumentInputData(input: any){
  const data = {
    transactionId: input.transactionId,
    sourceType: input.sourceType,
    option: {
      documentVersion: 0,
      templateVersion: 0,
      headerOptionType: input.headerType,
      language: 1,
    },
  };
  return data;
}

export function PrepareWithHoldingTaxDocumentPublicLinkInputData(input: any){
  const data = {
    transactionId: input.transactionId,
    sourceType: input.sourceType,
    passCode: input.passCode,
    option: {
        documentVersion: 0,
        templateVersion: 0,
        headerOptionType: input.headerType,
        language: 1,
      },
  };
  return data;
}

export function GetWitholdingTaxSettingDocument(): SettingWitholdingTaxDocumentTemplateModel {
  let settingTemplate = new SettingWitholdingTaxDocumentTemplateModel();

  settingTemplate = {
    pageSize: WithholdingTaxPageSizeType.A4,
    displayType: WitholdingTaxDocumentDisplayType.ShowOnlyOneAndTwo,
    showDisplayType: true,
    documentNumber: {
      isShowRefOne: true,
      isShowRefTwo: true,
      isShowWhtNumber: true,
    },
    certified: {
      isShowUserCreateUrl: true,
      isShowUserApproveUrl: true,
      isShowUserCreateDate: true,
      isShowUserApproveDate: true,
      isShowUserApproveName: true,
      isShowUserCreateName: true,
      isShowMerchantStampUrl: true,
    },
    whtItem40XShowingType: SettingWhtItem40XShowingType.CombinedShowing,
  };

  return settingTemplate;
}
